import React from 'react';

const DashboardMockup = () => {
  return (
    <div className="dashboard-mockup">
      {/* Sidebar Mockup */}
      <div className="mockup-sidebar">
        <div className="mockup-logo"></div>
        <div className="mockup-nav">
          <div className="mockup-nav-item active"></div>
          <div className="mockup-nav-item"></div>
          <div className="mockup-nav-item"></div>
          <div className="mockup-nav-item"></div>
        </div>
      </div>

      {/* Main Content Mockup */}
      <div className="mockup-content">
        <header className="mockup-header">
          <div className="mockup-search"></div>
          <div className="mockup-user"></div>
        </header>

        <div className="mockup-body">
          {/* Stats Row */}
          <div className="mockup-stats">
            <div className="mockup-stat-card">
              <div className="mockup-label">Gestión de Usuarios</div>
              <div className="mockup-value">1,284</div>
              <div className="mockup-trend up">+12%</div>
            </div>
            <div className="mockup-stat-card">
              <div className="mockup-label">Trazabilidad de Lotes</div>
              <div className="mockup-value">84</div>
              <div className="mockup-trend">Stable</div>
            </div>
            <div className="mockup-stat-card">
              <div className="mockup-label">Operativa Diaria</div>
              <div className="mockup-value">€4,250</div>
              <div className="mockup-trend up">+5%</div>
            </div>
          </div>

          {/* Chart Area */}
          <div className="mockup-chart-container">
            <div className="mockup-chart-header">Analítica de Rendimiento</div>
            <div className="mockup-chart">
              <div className="mockup-bar" style={{ height: '40%' }}></div>
              <div className="mockup-bar" style={{ height: '65%' }}></div>
              <div className="mockup-bar" style={{ height: '50%' }}></div>
              <div className="mockup-bar" style={{ height: '85%' }}></div>
              <div className="mockup-bar" style={{ height: '70%' }}></div>
              <div className="mockup-bar" style={{ height: '90%' }}></div>
            </div>
          </div>

          {/* Table Area */}
          <div className="mockup-table">
            <div className="mockup-table-row header">
              <span>Identificador</span>
              <span>Categoría</span>
              <span>Estado</span>
            </div>
            <div className="mockup-table-row">
              <span>#L-9921</span>
              <span>Suministro B</span>
              <span className="status-pill">Verificado</span>
            </div>
            <div className="mockup-table-row">
              <span>#L-9922</span>
              <span>Suministro A</span>
              <span className="status-pill">En Proceso</span>
            </div>
          </div>
        </div>
      </div>

      <style dangerouslySetInnerHTML={{ __html: `
        .dashboard-mockup {
          width: 100%;
          height: 480px;
          background: #f3f4f6;
          border-radius: 12px;
          display: flex;
          overflow: hidden;
          box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
          border: 1px solid #e5e7eb;
          font-family: sans-serif;
        }

        .mockup-sidebar {
          width: 60px;
          background: #111827;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 20px 0;
        }

        .mockup-logo {
          width: 32px;
          height: 32px;
          background: #059669;
          border-radius: 8px;
          margin-bottom: 40px;
        }

        .mockup-nav-item {
          width: 24px;
          height: 24px;
          background: #374151;
          border-radius: 6px;
          margin-bottom: 20px;
        }

        .mockup-nav-item.active {
          background: #059669;
        }

        .mockup-content {
          flex: 1;
          display: flex;
          flex-direction: column;
        }

        .mockup-header {
          height: 60px;
          background: white;
          border-bottom: 1px solid #e5e7eb;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 24px;
        }

        .mockup-search {
          width: 200px;
          height: 32px;
          background: #f3f4f6;
          border-radius: 16px;
        }

        .mockup-user {
          width: 32px;
          height: 32px;
          background: #e5e7eb;
          border-radius: 50%;
        }

        .mockup-body {
          padding: 24px;
          display: flex;
          flex-direction: column;
          gap: 24px;
        }

        .mockup-stats {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 16px;
        }

        .mockup-stat-card {
          background: white;
          padding: 16px;
          border-radius: 8px;
          border: 1px solid #e5e7eb;
        }

        .mockup-label {
          font-size: 10px;
          color: #6b7280;
          text-transform: uppercase;
          margin-bottom: 4px;
        }

        .mockup-value {
          font-size: 18px;
          font-weight: 700;
          color: #111827;
        }

        .mockup-trend {
          font-size: 10px;
          margin-top: 4px;
          color: #6b7280;
        }

        .mockup-trend.up {
          color: #059669;
        }

        .mockup-chart-container {
          background: white;
          padding: 16px;
          border-radius: 8px;
          border: 1px solid #e5e7eb;
          flex: 1;
        }

        .mockup-chart-header {
          font-size: 12px;
          font-weight: 600;
          margin-bottom: 16px;
        }

        .mockup-chart {
          height: 100px;
          display: flex;
          align-items: flex-end;
          gap: 8px;
        }

        .mockup-bar {
          flex: 1;
          background: #059669;
          border-radius: 4px 4px 0 0;
          opacity: 0.8;
        }

        .mockup-table {
          background: white;
          border-radius: 8px;
          border: 1px solid #e5e7eb;
          overflow: hidden;
        }

        .mockup-table-row {
          display: flex;
          justify-content: space-between;
          padding: 12px 16px;
          border-bottom: 1px solid #f3f4f6;
          font-size: 12px;
        }

        .mockup-table-row.header {
          background: #f9fafb;
          font-weight: 600;
          font-size: 10px;
          color: #6b7280;
          text-transform: uppercase;
        }

        .status-pill {
          padding: 2px 8px;
          background: #ecfdf5;
          color: #059669;
          border-radius: 99px;
          font-size: 10px;
        }
      `}} />
    </div>
  );
};

export default DashboardMockup;
